import React, { Fragment } from "react";
import { translate } from "../Services/translation";

const ProductPrice = ({ price, campaignEnd }) => {
  if (!price) {
    return null; // Return null if price is undefined or null to avoid rendering errors
  }

  const originalAndCampaign =
    price.campaignPrice != null ? "two-priceRows product__price-wrap" : "product__price-wrap";
  const oldPrice = price.campaignPrice != null ? "old-price" : "price";

  const showOldPrice =
    (price.tierPrices &&
      price.tierPrices.length > 0 &&
      price.secondaryPrice > price.tierPrices[0].price) ||
    (price.campaignPrice && price.secondaryPrice > price.campaignPrice.price);

  const showSecondaryOldPrice =
    (price.tierPrices &&
      price.tierPrices.length > 0 &&
      price.secondaryPrice > price.tierPrices[0].price) ||
    price.secondaryPrice > price.price.price;

  return (
    <div className={originalAndCampaign} itemProp="offers" itemScope itemType="http://schema.org/Offer">
      <div itemProp="price" className={oldPrice}>
        {price.tierPrices && price.tierPrices.length > 0 ? (
          <Fragment>
            <span className="product__price-from-label">
              {translate("product.pricefrom")}
            </span>
            <span>{price.formattedTierPrice}</span>
          </Fragment>
        ) : (
          <span>{price.formattedBasePrice}</span>
        )}
      </div>

      {price.campaignPrice && (
        <div className="product__campaign-price">
          <span itemProp="price">
            {price.tierPrices && price.tierPrices.length > 0 ? (
              <Fragment>
                {translate("product.pricefrom")} {price.formattedCampaignPrice}
              </Fragment>
            ) : (
              <Fragment>{price.formattedCampaignPrice}</Fragment>
            )}
          </span>

          {campaignEnd && (
            <span className="campaign-left">
              <i className="icon ion-md-alert"></i>
              {translate("product.campaignend", {
                days: Math.floor(campaignEnd / (24 * 60 * 60 * 1000)),
                hours: Math.floor((campaignEnd % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)),
              })}
            </span>
          )}

          {showOldPrice && (
            <span className="product__old-price">
              ({price.formattedSecondaryPrice})
            </span>
          )}
        </div>
      )}

      {showSecondaryOldPrice && (
        <span className="product__old-price">
          ({price.formattedSecondaryPrice})
        </span>
      )}

      <meta itemProp="priceCurrency" content={price.currency} />
    </div>
  );
};

export default ProductPrice;
